import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import { Button } from '@repo/ui';
import { useIsMobile } from '@repo/mui-config/hooks';

import { LoanProcessStatusIconWrapper } from '@/components/loan-process/loan-process-status-icon-wrapper';
import { useLoanProcessSetCurrentModalState } from '@/components/loan-process/hooks/use-loan-process-set-current-modal-state';
import { useLoanProcessStore } from '@/components/loan-process/store/loan-process.store';
import { LoanProcessModalHeader } from '@/components/loan-process/loan-process-modal/loan-process-modal-header';

export function AgreementSmsTooManyAttempts() {
  const isMobile = useIsMobile();
  useLoanProcessSetCurrentModalState('AgreementSmsTooManyAttempts');
  const { t } = useTranslation();
  const {
    actions: { clearLoanProcessStore },
  } = useLoanProcessStore();

  return (
    <Box data-testid="agreement-sms-too-many-attempts" sx={{ px: isMobile ? 2 : 4, py: 4 }}>
      <LoanProcessModalHeader containerSx={{ mb: 4 }} />
      <Stack alignContent="center" alignItems="center" gap={7} sx={{ marginBottom: '40px' }}>
        <Typography component="p" sx={{ textAlign: 'center' }} variant="h5">
          {t('loanProcess.loanSteps.sms.tooManyAttempts.title.wrongSMSCode')}
          <br />
          {t('loanProcess.loanSteps.sms.tooManyAttempts.title.limit')}
        </Typography>
        <LoanProcessStatusIconWrapper iconType="error">
          <CloseIcon />
        </LoanProcessStatusIconWrapper>
        <Typography sx={{ marginY: 2, textAlign: 'center' }}>
          {t('loanProcess.loanSteps.sms.tooManyAttempts.description')}
        </Typography>
      </Stack>
      <Button
        color="secondary"
        data-testid="agreement-sms-too-many-attempts-button"
        fullWidth
        onClick={clearLoanProcessStore}
        sx={{ paddingY: { md: '14px', xs: '8px' } }}
        variant="contained"
      >
        {t('loanProcess.loanSteps.sms.tooManyAttempts.button')}
      </Button>
    </Box>
  );
}
